import { Component, Input, OnInit } from '@angular/core'
import { TableData } from '../../../models/table-data'

@Component({
  selector: 'jml-lib-entity-generic-attachments',
  templateUrl: './entity-generic-attachments.component.html',
  styleUrls: ['./entity-generic-attachments.component.scss']
})
export class EntityGenericAttachmentsComponent implements OnInit {
  @Input() attachmentType: string
  @Input() ownerType: string
  @Input() ownerId: number

  attachmentTableData: TableData

  constructor() {}

  ngOnInit(): void {
    this.attachmentTableData = new TableData(this.attachmentType).hideAttachments().hideHeader()
  }
}
